var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayStoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 44,
    viewBox: "0 0 149 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 147.5,
    height: 43,
    rx: 7.5,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 147.5,
    height: 43,
    rx: 7.5,
    stroke: "#A6A6A6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.9479 23.9262C72.3607 23.9262 70.252 25.8941 70.252 28.6045C70.252 31.2984 72.3607 33.2828 74.9479 33.2828C77.5362 33.2828 79.6449 31.2984 79.6449 28.6045C79.6438 25.8941 77.5351 23.9262 74.9479 23.9262ZM74.9479 31.4414C73.53 31.4414 72.3079 30.2721 72.3079 28.6056C72.3079 26.9215 73.5311 25.7698 74.9479 25.7698C76.3658 25.7698 77.5879 26.9215 77.5879 28.6056C77.5879 30.271 76.3658 31.4414 74.9479 31.4414ZM64.7025 23.9262C62.1153 23.9262 60.0066 25.8941 60.0066 28.6045C60.0066 31.2984 62.1153 33.2828 64.7025 33.2828C67.2908 33.2828 69.3995 31.2984 69.3995 28.6045C69.3995 25.8941 67.2908 23.9262 64.7025 23.9262ZM64.7025 31.4414C63.2846 31.4414 62.0625 30.2721 62.0625 28.6056C62.0625 26.9215 63.2857 25.7698 64.7025 25.7698C66.1204 25.7698 67.3425 26.9215 67.3425 28.6056C67.3436 30.271 66.1204 31.4414 64.7025 31.4414ZM52.5167 25.3628V27.3472H57.2665C57.1246 28.4637 56.7528 29.2788 56.1852 29.8453C55.4944 30.5361 54.4131 31.2984 52.5167 31.2984C49.5929 31.2984 47.3071 28.9411 47.3071 26.0173C47.3071 23.0935 49.5929 20.7362 52.5167 20.7362C54.0941 20.7362 55.2458 21.3566 56.0961 22.1541L57.4964 20.7538C56.3084 19.6197 54.7321 18.7518 52.5167 18.7518C48.5116 18.7518 45.1445 22.0122 45.1445 26.0173C45.1445 30.0224 48.5116 33.2828 52.5167 33.2828C54.6782 33.2828 56.3095 32.5733 57.5844 31.2445C58.8956 29.9333 59.3037 28.0897 59.3037 26.6014C59.3037 26.1416 59.2685 25.7159 59.197 25.3617H52.5167V25.3628ZM102.356 26.9039C101.966 25.8589 100.778 23.9262 98.3504 23.9262C95.9403 23.9262 93.9372 25.8226 93.9372 28.6045C93.9372 31.2269 95.9227 33.2828 98.5803 33.2828C100.724 33.2828 101.965 31.9716 102.48 31.2093L100.885 30.1456C100.354 30.9255 99.6264 31.4392 98.5803 31.4392C97.5353 31.4392 96.7906 30.9607 96.3121 30.0213L102.568 27.4341L102.356 26.9039ZM95.9755 28.4637C95.9227 26.6553 97.3758 25.7346 98.4219 25.7346C99.237 25.7346 99.9278 26.1427 100.159 26.7268L95.9755 28.4637ZM90.8902 33.0001H92.945V19.249H90.8902V33.0001ZM87.522 24.9723H87.4516C86.9907 24.4223 86.1041 23.9262 84.9887 23.9262C82.649 23.9262 80.5051 25.9821 80.5051 28.6232C80.5051 31.2456 82.649 33.2839 84.9887 33.2839C86.1052 33.2839 86.9907 32.7878 87.4516 32.2213H87.522V32.8945C87.522 34.6842 86.565 35.6412 85.0239 35.6412C83.7655 35.6412 82.9856 34.7381 82.6666 33.9758L80.8769 34.7205C81.3906 35.9602 82.7546 37.4848 85.0239 37.4848C87.434 37.4848 89.4723 36.0669 89.4723 32.6107V24.2111H87.5231V24.9723H87.522ZM85.1658 31.4414C83.7479 31.4414 82.561 30.2534 82.561 28.6232C82.561 26.9743 83.7479 25.7698 85.1658 25.7698C86.565 25.7698 87.6639 26.9743 87.6639 28.6232C87.6639 30.2534 86.565 31.4414 85.1658 31.4414ZM111.985 19.249H107.067V33.0001H109.118V27.7905H111.984C114.259 27.7905 116.496 26.1438 116.496 23.5203C116.496 20.8968 114.26 19.249 111.985 19.249ZM112.038 25.8765H109.118V21.163H112.038C113.572 21.163 114.443 22.4335 114.443 23.5203C114.443 24.5851 113.572 25.8765 112.038 25.8765ZM124.723 23.902C123.237 23.902 121.698 24.5565 121.061 26.0074L122.883 26.7675C123.272 26.0074 123.998 25.7588 124.758 25.7588C125.82 25.7588 126.899 26.3957 126.916 27.5276V27.6695C126.545 27.4572 125.748 27.1393 124.776 27.1393C122.812 27.1393 120.812 28.2184 120.812 30.2347C120.812 32.075 122.423 33.2597 124.227 33.2597C125.606 33.2597 126.367 32.6404 126.845 31.9144H126.915V32.9759H128.897V27.7036C128.899 25.2638 127.075 23.902 124.723 23.902ZM124.474 31.4381C123.803 31.4381 122.865 31.1015 122.865 30.2699C122.865 29.2084 124.033 28.8014 125.042 28.8014C125.943 28.8014 126.369 28.9961 126.916 29.2612C126.757 30.5361 125.66 31.4381 124.474 31.4381ZM136.116 24.2023L133.763 30.1643H133.692L131.25 24.2023H129.039L132.701 32.5348L130.613 37.1702H132.754L138.398 24.2023H136.116ZM117.629 33.0001H119.681V19.249H117.629V33.0001Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1609 11.2672C52.1609 12.189 51.8881 12.9227 51.3414 13.4705C50.721 14.1217 49.9114 14.4473 48.917 14.4473C47.9644 14.4473 47.1537 14.1173 46.4882 13.4573C45.8216 12.7962 45.4883 11.9778 45.4883 11.001C45.4883 10.0231 45.8216 9.20474 46.4882 8.54474C47.1537 7.88364 47.9644 7.55364 48.917 7.55364C49.39 7.55364 49.8421 7.64604 50.2711 7.82974C50.7012 8.01454 51.0455 8.25984 51.3029 8.56674L50.7232 9.14754C50.2865 8.62504 49.6848 8.36434 48.9159 8.36434C48.2207 8.36434 47.6201 8.60854 47.113 9.09694C46.6059 9.58534 46.3529 10.22 46.3529 10.9999C46.3529 11.7798 46.6059 12.4145 47.113 12.9029C47.6201 13.3913 48.2207 13.6355 48.9159 13.6355C49.6529 13.6355 50.2678 13.3902 50.7595 12.8985C51.0785 12.5784 51.2633 12.1329 51.3128 11.562H48.9159V10.7689H52.1136C52.1466 10.9416 52.1609 11.1077 52.1609 11.2672Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.232 8.5107H54.2268V10.6029H56.9372V11.396H54.2268V13.4882H57.232V14.3H53.3787V7.7H57.232V8.5107Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.808 14.3H59.9599V8.5107H58.1163V7.7H62.6516V8.5107H60.808V14.3Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9328 14.3V7.7H66.7809V14.3H65.9328Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.542 14.3H69.6939V8.5107H67.8503V7.7H72.3856V8.5107H70.542V14.3Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9708 13.4475C80.3218 14.1141 79.5155 14.4474 78.5508 14.4474C77.5861 14.4474 76.7798 14.1141 76.1319 13.4475C75.4829 12.7809 75.1595 11.9647 75.1595 11C75.1595 10.0353 75.4829 9.21909 76.1319 8.55249C76.7798 7.88589 77.5861 7.55149 78.5508 7.55149C79.51 7.55149 80.3153 7.88699 80.9664 8.55689C81.6176 9.22679 81.9432 10.0408 81.9432 11C81.9432 11.9647 81.6187 12.7809 80.9708 13.4475ZM76.7578 12.8942C77.2462 13.3892 77.8435 13.6356 78.5508 13.6356C79.2581 13.6356 79.8565 13.3881 80.3438 12.8942C80.8322 12.3992 81.0775 11.7678 81.0775 11C81.0775 10.2322 80.8322 9.60079 80.3438 9.10579C79.8565 8.61079 79.2581 8.36439 78.5508 8.36439C77.8435 8.36439 77.2462 8.61189 76.7578 9.10579C76.2705 9.60079 76.0252 10.2322 76.0252 11C76.0252 11.7678 76.2705 12.3992 76.7578 12.8942Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1335 14.3V7.7H84.1653L87.3729 12.8337H87.4092L87.3729 11.5621V7.7H88.221V14.3H87.3355L83.9794 8.9166H83.9431L83.9794 10.1882V14.3H83.1335Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1609 11.2672C52.1609 12.189 51.8881 12.9227 51.3414 13.4705C50.721 14.1217 49.9114 14.4473 48.917 14.4473C47.9644 14.4473 47.1537 14.1173 46.4882 13.4573C45.8216 12.7962 45.4883 11.9778 45.4883 11.001C45.4883 10.0231 45.8216 9.20474 46.4882 8.54474C47.1537 7.88364 47.9644 7.55364 48.917 7.55364C49.39 7.55364 49.8421 7.64604 50.2711 7.82974C50.7012 8.01454 51.0455 8.25984 51.3029 8.56674L50.7232 9.14754C50.2865 8.62504 49.6848 8.36434 48.9159 8.36434C48.2207 8.36434 47.6201 8.60854 47.113 9.09694C46.6059 9.58534 46.3529 10.22 46.3529 10.9999C46.3529 11.7798 46.6059 12.4145 47.113 12.9029C47.6201 13.3913 48.2207 13.6355 48.9159 13.6355C49.6529 13.6355 50.2678 13.3902 50.7595 12.8985C51.0785 12.5784 51.2633 12.1329 51.3128 11.562H48.9159V10.7689H52.1136C52.1466 10.9416 52.1609 11.1077 52.1609 11.2672Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.232 8.5107H54.2268V10.6029H56.9372V11.396H54.2268V13.4882H57.232V14.3H53.3787V7.7H57.232V8.5107Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M60.808 14.3H59.9599V8.5107H58.1163V7.7H62.6516V8.5107H60.808V14.3Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9328 14.3V7.7H66.7809V14.3H65.9328Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M70.542 14.3H69.6939V8.5107H67.8503V7.7H72.3856V8.5107H70.542V14.3Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9708 13.4475C80.3218 14.1141 79.5155 14.4474 78.5508 14.4474C77.5861 14.4474 76.7798 14.1141 76.1319 13.4475C75.4829 12.7809 75.1595 11.9647 75.1595 11C75.1595 10.0353 75.4829 9.21909 76.1319 8.55249C76.7798 7.88589 77.5861 7.55149 78.5508 7.55149C79.51 7.55149 80.3153 7.88699 80.9664 8.55689C81.6176 9.22679 81.9432 10.0408 81.9432 11C81.9432 11.9647 81.6187 12.7809 80.9708 13.4475ZM76.7578 12.8942C77.2462 13.3892 77.8435 13.6356 78.5508 13.6356C79.2581 13.6356 79.8565 13.3881 80.3438 12.8942C80.8322 12.3992 81.0775 11.7678 81.0775 11C81.0775 10.2322 80.8322 9.60079 80.3438 9.10579C79.8565 8.61079 79.2581 8.36439 78.5508 8.36439C77.8435 8.36439 77.2462 8.61189 76.7578 9.10579C76.2705 9.60079 76.0252 10.2322 76.0252 11C76.0252 11.7678 76.2705 12.3992 76.7578 12.8942Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1335 14.3V7.7H84.1653L87.3729 12.8337H87.4092L87.3729 11.5621V7.7H88.221V14.3H87.3355L83.9794 8.9166H83.9431L83.9794 10.1882V14.3H83.1335Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_431_19345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4781 8.2918C11.158 8.6306 10.9687 9.1564 10.9687 9.8373V34.1649C10.9687 34.8469 11.158 35.3716 11.4781 35.7104L11.5595 35.7896L25.1874 22.1617V22.0011V21.8405L11.5595 8.2115L11.4781 8.2918Z",
    fill: "url(#paint0_linear_431_19345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7294 26.7058L25.1875 22.1617V22.0011V21.8405L29.7305 17.2975L29.8328 17.3558L35.2151 20.4138C36.7518 21.2872 36.7518 22.7161 35.2151 23.5906L29.8328 26.6486L29.7294 26.7058Z",
    fill: "url(#paint1_linear_431_19345)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_431_19345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.8312 26.6475L25.1848 22.0011L11.4766 35.7104C11.9826 36.2472 12.8197 36.3132 13.7624 35.7786L29.8312 26.6475Z",
    fill: "url(#paint2_linear_431_19345)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.8312 17.3547L13.7624 8.2247C12.8197 7.689 11.9826 7.7561 11.4766 8.2929L25.1859 22.0022L29.8312 17.3547Z",
    fill: "url(#paint3_linear_431_19345)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_431_19345",
    x: 10.9688,
    y: 7.85502,
    width: 25.3984,
    height: 28.2928,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_431_19345"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_431_19345",
    result: "effect2_innerShadow_431_19345"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_431_19345",
    x: 11.4766,
    y: 22.0011,
    width: 18.3555,
    height: 14.1467,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_431_19345"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_431_19345",
    x1: 23.9793,
    y1: 9.5799,
    x2: 5.51913,
    y2: 28.0401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_431_19345",
    x1: 37.2154,
    y1: 22.0011,
    x2: 10.6,
    y2: 22.0011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_431_19345",
    x1: 27.3079,
    y1: 24.5244,
    x2: 2.27353,
    y2: 49.5587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_431_19345",
    x1: 8.0241,
    y1: 0.194481,
    x2: 19.2026,
    y2: 11.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStoreIcon);
export default __webpack_public_path__ + "static/media/play-store-icon.8aabf2a5691bc1e533b1dfdddb79e62b.svg";
export { ForwardRef as ReactComponent };